import { DefaultTheme } from 'styled-components';

const transitions: DefaultTheme['transitions'] = {
  duration: '.275s',
  type: 'ease-in-out',
  curve: 'cubic-bezier(0.0, 0.005, 0.2, 1.0)',
};

export default transitions;
